import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@material-ui/core';

const CircularProgressWithLabel = props => {
    return (
        <Box style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle' }}>
            <CircularProgress variant="determinate" {...props} style={{ color: '#00823c'}} />
            <Box
                style={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                }}
            >
                <Typography
                variant="caption"
                component="div"
                style={{ color: 'text.secondary' }}
                >
                {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
};

CircularProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
};

export default CircularProgressWithLabel;